<template>
  <div class="flex flex-col w-full border-blue-800 border-8">

      <ring-loader v-if="showLoader"></ring-loader>

      <div class="flex justify-center items-center mt-10 mb-10 w-full px-2 lg:pl-20">

            
            <label class="mr-1 lg:mr-5"><strong>{{$t('profile.profilePicture')}}: </strong></label>

            <!-- <div v-if="!isLoadingImage"> -->

                <img :src="userImage" class="mg-1 lg:ms-5 rounded-lg" height="100" id="profileImage" ref="profileImageRef" width="100"/>
      </div>


      <div class="flex justify-center items-center mt-10 mb-10 w-full">
                     
            <label class="mr-5"><strong>{{$t('profile.fullName')}}: </strong></label>

            
            <label
            class="me-5 p-5 bg-blue-300  rounded-full border-blue-800 border-4">
            {{userInfo.name}}</label>
      </div>


        <div class="flex justify-center items-center mb-10 w-full">
                     
            <label class="me-5" ><strong>{{$t('profile.dateOfBirth')}}: </strong></label>

            
            <label
            class="me-5 p-5 bg-blue-300  rounded-full border-blue-800 border-4">
            {{userInfo.date_of_birth}}</label>

      </div>

        <div class="flex justify-center items-center mb-10 w-full">
                     
            <label class="me-5"><strong>{{$t('profile.gender')}}: </strong></label>

            <label
            class="me-5 p-5 bg-blue-300  rounded-full border-blue-800 border-4">
            {{userInfo.gender}}</label>

      </div>

        <div class="flex justify-center items-center mb-10 w-full">
                     
            <label class="me-5"><strong>{{$t('profile.phone')}}: </strong></label>

            
           <label
            class="me-5 p-5 bg-blue-300  rounded-full border-blue-800 border-4">
            {{phone}}</label>

      </div>

        <div class="flex justify-center items-center mb-10 w-full">
                     
            <label class="me-5"><strong>{{$t('profile.nationality')}}: </strong></label>

            <label
            class="me-5 p-5 bg-blue-300  rounded-full border-blue-800 border-4">
            {{userInfo.nationality}}</label>

      </div>

        <div class="flex justify-center items-center mb-10 w-full">
                     
            <label class="me-5"><strong>{{$t('profile.address')}}: </strong></label>

            
            <label
           class="me-5 p-5 bg-blue-300  rounded-full border-blue-800 border-4">
            {{userInfo.address}}</label>
      </div>

        <div class="flex justify-center items-center mb-10 w-full">
                     
            <label v-if="$countryCode == 'KW'" class="me-5"><strong>{{$t('profile.civilId')}}: </strong></label>

            <label v-else class="me-5"><strong>{{$t('profile.id')}}: </strong></label>

            
            <label
            class="me-5 p-5 bg-blue-300  rounded-full border-blue-800 border-4">
            {{userInfo.identification_number}}</label>
      </div>

      <div v-if="userInfo.is_business" class="flex justify-center items-center mb-10 w-full">
                    
          <label class="me-5"><strong>{{$t('profile.socialMedia')}}: </strong></label>

          
          <label
          class="me-5 p-5 bg-blue-300  rounded-full border-blue-800 border-4">
          <a :href="`//${userInfo.social_media}`" target="_blank" rel="noreferrer"
>{{socialMedia}}</a></label>
      </div>
  </div>
</template>

<script>

import firebase from '../../classes/firebase';

export default {

  created()
  {

    //   console.log(`in profile view`);
  },

  props: {

    tokenId: '',
    userInfo:{
      
      type: Object,
      default: () => ({})
            },
  },
  components: {

    // BaseProgress
  },

  mounted(){

    let phone = this.userInfo.in_phone.substring(this.userInfo.in_phone.indexOf(' ') + 1);

    // phone = phone.substring(phone.indexOf(' ') + 1);

    this.phone = phone.replace(' ', '');
    //  console.log(`***********this image is ${this.userInfo.picture}`);
    },
  methods: {

  },


  data: function() {

    return {

      showLoader: false,
      phone: '',
      userImage: this.userInfo.picture !== '' ? this.userInfo.picture : require('@/assets/images/user_unisex.jpg'),
      socialMedia: this.userInfo.social_media.length > 10 ? this.userInfo.social_media.slice(0,12) : this.userInfo.social_media
    }
  },

  
}
</script>

<style lang="scss">

label{
  width: 150px;
}


</style>